import { c as _c } from "react/compiler-runtime";
import type { transformCreditCardsMultiCompareEntities } from '@cc-shopping/structured-content-renderer/hydration/CreditCardsMultiCompare/transform';
import type { StructuredContentDocumentWithRenderer } from '@cc-shopping/structured-content-renderer/hydration/types';
import { renderStructuredContent } from '@cc-shopping/structured-content-renderer/renderContext';
import type * as v from 'valibot';
import { CreditCardsMultiCompareClient } from './CreditCardsMultiCompare.client';
import type { creditCardsMultiCompareSchema } from './schema';
export type CardCardsMultiCompareProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof creditCardsMultiCompareSchema> & {
  marketplaceEntities: ReturnType<typeof transformCreditCardsMultiCompareEntities>;
}>;
export const CreditCardsMultiCompare = t0 => {
  const $ = _c(6);
  const {
    props
  } = t0;
  const {
    marketplaceEntities,
    disableMonetization,
    children
  } = props;
  const t1 = disableMonetization ?? false;
  let t2;
  if ($[0] !== children) {
    t2 = renderStructuredContent(children);
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== marketplaceEntities || $[3] !== t1 || $[4] !== t2) {
    t3 = <CreditCardsMultiCompareClient marketplaceEntities={marketplaceEntities} disableMonetization={t1}>{t2}</CreditCardsMultiCompareClient>;
    $[2] = marketplaceEntities;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};